/* Guida taglie: mostra traversina e sagoma del cane in proporzione (cm reali) per la taglia scelta.
   Collega le schede taglia alla scelta della variante senza far scorrere la pagina. */
(function () {
  'use strict';
  if (window.__tlSizes) return;
  window.__tlSizes = true;

  function num(v) { return parseFloat(String(v).replace(',', '.')); }
  function same(value, name) {
    var v = String(value || '').trim().toLowerCase(), n = String(name || '').trim().toLowerCase();
    if (!n) return false;
    return v === n || v.indexOf(n + ' ') === 0 || v.indexOf(n + '(') === 0;
  }

  function init(root) {
    var jsonEl = root.querySelector('[data-tl-sizes-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var cards = root.querySelectorAll('[data-tl-size]');
    var viz = root.querySelector('[data-tl-viz]');
    function q(sel) { return viz ? viz.querySelector(sel) : null; }
    var pad = q('[data-viz-pad]'), dog = q('[data-viz-dog]');
    var wl = q('[data-viz-w]'), hl = q('[data-viz-h]');
    var nameEl = q('[data-viz-name]'), dimEl = q('[data-viz-dim]'), dogEl = q('[data-viz-dogtext]');
    var cw = viz ? num(viz.dataset.cmW) || 140 : 140, ch = viz ? num(viz.dataset.cmH) || 105 : 105;
    var current = -1;

    function show(i) {
      var d = data[i];
      if (!d) return;
      current = i;
      cards.forEach(function (c, j) { c.classList.toggle('is-selected', j === i); c.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      if (!viz) return;
      var m = String(d.dims).match(/(\d+(?:[.,]\d+)?)\s*[x×*]\s*(\d+(?:[.,]\d+)?)/i);
      if (m && pad) {
        var a = num(m[1]), b = num(m[2]), w = Math.max(a, b), h = Math.min(a, b);
        pad.style.width = (w / cw * 100) + '%';
        pad.style.height = (h / ch * 100) + '%';
        if (wl) wl.textContent = String(w).replace('.', ',') + ' cm';
        if (hl) hl.textContent = String(h).replace('.', ',') + ' cm';
      }
      if (dog) dog.style.width = (num(d.dog) * 1.15 / cw * 100) + '%';
      if (nameEl) nameEl.textContent = d.name;
      if (dimEl) dimEl.textContent = d.dims;
      if (dogEl) dogEl.textContent = d.dogText;
    }

    function selectVariant(name) {
      var inputs = document.querySelectorAll('[data-tl-option] input');
      var input = Array.prototype.find.call(inputs, function (x) { return same(x.value, name); });
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { show(i); selectVariant(data[i].name); });
    });

    document.addEventListener('tl:variant', function (e) {
      var opts = (e.detail && e.detail.options) || [];
      for (var i = 0; i < data.length; i++) {
        if (opts.some(function (o) { return same(o, data[i].name); })) { if (i !== current) show(i); return; }
      }
    });

    var start = -1;
    document.querySelectorAll('[data-tl-option] input:checked').forEach(function (x) {
      data.forEach(function (d, i) { if (start < 0 && same(x.value, d.name)) start = i; });
    });
    show(start < 0 ? 0 : start);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-tl-sizes2]:not([data-tl-ready])').forEach(function (el) { el.dataset.tlReady = '1'; init(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
